const log = require("../shared_utils/log.js");
const { getNewSceneId } = require("./utils/import-export-helpers.js");
module.exports = function store(state, emitter) {
  emitter.on("toggle-scene-manager", () => {
    state.isSceneManagerOpen = !state.isSceneManagerOpen;
    emitter.emit("render");
  });

  emitter.on("select-scene-page", (page) => {
    state.currentScenePage = page;
    emitter.emit("render");
  });

  emitter.on("toggle-display-levels", () => {
    const showLevelsPanel = state.showLevelsPanel;
    emitter.emit("deselect-all");
    state.showLevelsPanel = !showLevelsPanel;
    state.currentScenePage = null;

    emitter.emit("render");
  });
  emitter.on("show-levels", () => {
    state.showLevelsPanel = true;
    emitter.emit("render");
  });
  emitter.on("stop-renaming-scene", () => {
    log("stop-renaming-scene");
    const currentSceneId = state.currentScene.metadata.id;
    const matchingScenes = state.project.scenes.filter(
      (s) => s.metadata.id === currentSceneId
    );
    let index = 2;
    while (matchingScenes.length > 1) {
      state.currentScene.metadata.id = `${currentSceneId} (${index})`; 
      matchingScenes = state.project.scenes.filter(
        (s) => s.metadata.id === state.currentScene.metadata.id
      );

      index++;
    }
    state.renamingScene = false;
    emitter.emit("render");
  });
  emitter.on("rename-scene", (sceneId) => {
    log("rename-scene", sceneId);
    state.renamingScene = true;
    emitter.emit("render");
  });
  emitter.on("update-scene-name", (newName) => {
    log("update-scene-name", newName);
    state.currentScene.metadata.id = newName;
    emitter.emit("render");
  });
  emitter.on("create-new-scene", () => {
    log("create-new-scene");
    emitter.emit("deselect-all");
    emitter.emit("duplicate-scene", state.currentScene.metadata.id);
    state.vm.runtime.targets.forEach((t) => {
      state.vm.runtime.deleteTarget(t);
    });
    state.addedParts = [];
    state.glitchApplications = [];
    state.vm.runtime.renderer.draw();
    let currentHistory = state.getHistory();
    // remove all history items from the current scene
    while (currentHistory.length > 0) {
      currentHistory.shift();
    }

    emitter.emit("push-history", "new-scene");
    emitter.emit("render");
  });

  emitter.on("start-renaming-project", () => {
    log("start-renaming-project");
    state.isRenamingProject = true;
    emitter.emit("render");
  });

  emitter.on("stop-renaming-project", () => {
    log("stop-renaming-project");
    state.isRenamingProject = false;
    emitter.emit("render");
  });

  emitter.on("rename-project", (newProjectId) => {
    if (newProjectId === "") {
      newProjectId = "Untitled";
    }
    state.projectMetadata.id = newProjectId;
    state.projectMetadata.title = newProjectId;
    state.isRenamingProject = false;
    emitter.emit("render");
  });

  emitter.on("load-scene-by-id", (sceneId) => {
    log("load-scene-by-id", sceneId);
    const scene = state.project.scenes.find(
      (s) => s.metadata.id.toLowerCase() === sceneId.toLowerCase()
    );
    if (scene) {
      emitter.emit("load-scene", state.project.scenes.indexOf(scene));
    }
  });

  emitter.on("start-moving-scene", (sceneId) => {
    log("start-moving-scene");
    state.initialIdOfDraggingScene = sceneId;
    state.draggingSceneId = sceneId;
    emitter.emit("render");
  });
  emitter.on("swap-scenes", (id1, id2) => {
    log("swap-scenes", id1, id2);
    const scene1 = state.project.scenes.find((s) => s.metadata.id === id1);
    const scene2 = state.project.scenes.find((s) => s.metadata.id === id2);
    const index1 = state.project.scenes.indexOf(scene1);
    const index2 = state.project.scenes.indexOf(scene2);
    state.project.scenes[index1] = scene2;
    state.project.scenes[index2] = scene1;
    emitter.emit("render");
  });
  emitter.on("delete-scene", (sceneId) => {
    log("delete-scene", sceneId);
    if (
      state.currentScene.metadata.id === sceneId &&
      state.project.scenes.length > 1
    ) {
      state.isLoadingSceneForDeletion = true;
      const currentIndex = state.project.scenes.indexOf(state.currentScene);
      const previousSceneIndex = currentIndex - 1;
      const nextSceneIndex = currentIndex + 1;
      const sceneToLoad =
        state.project.scenes[previousSceneIndex] ||
        state.project.scenes[nextSceneIndex] ||
        state.project.scenes[0];
      emitter.emit("load-scene", state.project.scenes.indexOf(sceneToLoad));
    }
    state.project.scenes = state.project.scenes.filter(
      (s) => s.metadata.id !== sceneId
    );  
    emitter.emit("render");
  });

  emitter.on("duplicate-scene", (sceneId) => {
    log("duplicate-scene", sceneId);
    const scene = state.project.scenes.find((s) => s.metadata.id === sceneId);
    const newScene = { ...scene };
    newScene.metadata = { ...scene.metadata };
    newScene.metadata.id = getNewSceneId(newScene, state.project.scenes);
    state.project.scenes.push(newScene);
    emitter.emit("push-history", "new-scene");
    state.currentScene = newScene;
    state.showLevelsPanel = true;
    emitter.emit("render");
  });
};
